import clsx from 'clsx';
import { round } from 'lodash';
import { number, shape, string } from 'prop-types';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Card, TabsContext } from 'components';
import { routes } from 'router';
import { appService } from 'services';

const ConsumptionCard = ({ consumption, index }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setCurrentTab } = useContext(TabsContext);

  const location = useLocation();
  const colors = [
    { text: 'text-yellow-500', bg: 'bg-yellow-500', bgLight: 'bg-yellow-200' },
    { text: 'text-blue-500', bg: 'bg-blue-500', bgLight: 'bg-blue-200' },
    { text: 'text-green-500', bg: 'bg-green-500', bgLight: 'bg-green-200' },
    { text: 'text-red-500', bg: 'bg-red-500', bgLight: 'bg-red-200' },
    { text: 'text-pink-500', bg: 'bg-pink-500', bgLight: 'bg-pink-200' }
  ];

  const cardColor = useMemo(() => {
    return colors[index];
  }, [index]);

  const isAccountPage = location.pathname === routes.dashboard.children.account.path;

  const usedConsumption = appService.isTouloisirs() ? consumption.remaining : consumption.max - consumption.remaining;

  const navigateToBenefits = () => {
    setCurrentTab('benefits');
    navigate(routes.dashboard.children.benefits.path);
  };

  return (
    <Card className={clsx('consumption-card', isAccountPage && 'card-link')}>
      {isAccountPage && (
        <button type="button" className="absolute inset-0 opacity-0" onClick={navigateToBenefits}>
          {t('dashboard:seeBenefitsLink')}
        </button>
      )}

      <div className="flex justify-between items-center">
        <h3 className={clsx('h3', cardColor.text)}>{consumption.label}</h3>
      </div>

      <div className="flex items-baseline gap-2">
        <span className="font-semibold text-2xl tracking-widest">
          {round(usedConsumption || 0, 2)}/{consumption.max}
        </span>

        <span className="text-gray-500">{t('dashboard:remaining', { count: consumption.max })}</span>
      </div>

      <div className={clsx('w-full rounded-full h-1.5 overflow-hidden', cardColor.bgLight)}>
        <div
          className={clsx('h-full w-full', cardColor.bg)}
          style={{ width: (usedConsumption / consumption.max) * 100 + '%' }}
        ></div>
      </div>
    </Card>
  );
};

ConsumptionCard.propTypes = {
  consumption: shape({
    label: string.isRequired,
    remaining: number.isRequired,
    max: number.isRequired
  }).isRequired,
  index: number
};

export default ConsumptionCard;
